import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'

type Props = {
  count: number
}

export const Count = observer(({ count }: Props) => {
  if (count) return <Space pad={[0, 8]} height={20} round primary>
    <Typo size={11} medium>
      {count}
    </Typo>
  </Space>

  return <Space pad={[0, 8]} height={20} round panel>
    <Typo size={9} secondary nowrap>
      {i18n('NotSelected')}
    </Typo>
  </Space>
})
